export default {
    namespaced: true,
    state: {
        active: false,
        checked: false,
        text: '',
        showLink: false,
        link: '',
        linkName: '',
    },
    mutations: {
        INIT (state, config) {
            state.active = config.enabled;
            state.text = config.text;
            state.showLink = config.showLink;
            state.link = config.link;
            state.linkName = config.linkName;
        },
        SET (state, checked) {
            state.checked = checked;
        },
    }
}